<template>
  <div class="repertorio-adicionar">
    <v-container align-center justify-center class="container">
      <Card
        title="Adicionando Arranjo"
        text="Complete o formulário com as informações do arranjo"
        class="main-card"
      >
        <div class="infofield">
          <v-text-field label="Nome" filled v-model="nome"/>
          <v-text-field label="Artista" filled v-model="artista"/>
          <v-text-field label="Arranjador" filled v-model="arranjador"/>
          <v-text-field label="Código Identificador" filled hint="Este código não será alterável posteriormente" v-model="codigo" :rules="[v => !!v || 'Este campo é obrigatório']"/>
        </div>
        <div class="infofield">
          <v-text-field label="Link no Google Drive" filled v-model="linkDrive"/>
          <v-checkbox v-model="cantado" label="Este arranjo já foi cantado"/>
          <v-textarea label="Descrição" filled v-model="descricao"></v-textarea>
        </div>
        <div class="infofield">
          Salve este arranjo para poder adicionar arquivos.
        </div>
        <v-btn v-on:click.native="save" color="success" class="mt-4">Salvar</v-btn>
      </Card>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { db } from '../main'
import Card from '@/components/Card.vue'

export default {
  name: 'adicionarrepertorio',
  components: {
    Card
  },
  methods: {
    save: function (event) {
      if (!this.codigo.trim()) { // Checa se string está vazia
        console.log('Campo código identificador é obrigatório')
        alert('Campo Código Identificador é obrigatório')
        return
      }
      console.log('Verificando conflitos...')
      console.log(this.codigo)
      db.collection('repertorio')
        .where('codigo', '==', this.codigo)
        .get()
        .then(function (querySnapshot) {
          console.log(querySnapshot)
          if (!querySnapshot.empty) { // Já existe um arranjo com o código identificador digitado
            console.log('Já existe um arranjo com o código identificador digitado')
            alert('Já existe um arranjo com o código identificador digitado')
          } else {
            console.log('Salvando...')
            const repertorio = {}
            repertorio.nome = this.nome
            repertorio.codigo = this.codigo
            repertorio.arranjador = this.arranjador
            repertorio.artista = this.artista
            repertorio.linkDrive = this.linkDrive
            repertorio.avaliado = this.avaliado
            repertorio.files = this.files
            repertorio.descricao = this.descricao
            repertorio.cantado = this.cantado
            const rptTrim = {}
            rptTrim.arranjador = repertorio.arranjador
            rptTrim.artista = repertorio.artista
            rptTrim.avaliado = repertorio.avaliado
            rptTrim.codigo = repertorio.codigo
            rptTrim.nome = repertorio.nome
            rptTrim.cantado = repertorio.cantado
            db.collection('repertorio').doc(this.codigo).set(repertorio).then(function () {
              console.log('Sucesso')
              const update = {}
              update['repertorio.' + repertorio.codigo] = rptTrim
              db.collection('indice').doc('indice').update(update).then((a) => {
                if (a) {
                  console.log('Erro: ' + a)
                }
                console.log('Update aplicado ao indice')
              })
              this.$router.push({ name: 'Detalhes do Arranjo', params: { repertorioid: this.codigo } })
            }.bind(this)).catch(function (error) {
              console.error('Erro salvando documento: ' + error)
            })
          }
          // console.log('Salvo')
        }.bind(this))
      /*
      if (this.confirmedBox === false) aprSnapMod.confirmada = false
      else aprSnapMod.confirmada = true
      if (this.repertorioSerializado === '') {
        delete aprSnapMod.repertorio
      } else {
        aprSnapMod.repertorio = this.repertorioSerializado.split(',')
      }
      let tempDate = new Date(this.dataapr)
      tempDate.setUTCHours(3)
      if (this.dataapr !== '' && !aprSnapMod.dataprecisao) aprSnapMod.data = Timestamp.fromDate(tempDate)
      console.log(aprSnapMod)
      db.collection('apresentacoes')
        .doc(this.dbid)
        .set(aprSnapMod)
        .then(() => {
          console.log('Salvo')
          this.$router.push({ name: 'Detalhes da Apresentação', params: { apresentacaoid: this.apresentacaoid } })
        })
      */
    }
  },
  data () {
    return {
      nome: '',
      artista: '',
      codigo: '',
      descricao: '',
      arranjador: '',
      avaliado: false,
      linkDrive: '',
      files: [],
      cantado: 'false'
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 800px;
}
</style>
